import React, { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
import { consultantReportStyles as styles } from '../common/consultantReportStyles';

const NewConsultantReportModal: React.FC<React.PropsWithChildren<{ locked: boolean; onClose: () => void }>> = ({ locked, onClose, children }) => {
    const dialog = useRef<HTMLDialogElement>(null);
    useEffect(() => {
        const target = dialog.current;
        target?.showModal();
        return () => target?.close();
    }, []);
    return createPortal(<dialog ref={dialog} aria-labelledby="new-consultant-report-title"
        className={`${styles.panel} m-auto max-h-[90vh] w-[calc(100%_-_2rem)] max-w-3xl overflow-y-auto backdrop:bg-slate-950/60`}
        onCancel={event => { event.preventDefault(); if (!locked) onClose(); }}>
        <header className="mb-5 flex items-start justify-between gap-4"><div><h2 id="new-consultant-report-title" className="text-xl font-black">New report</h2>
            <p className={styles.muted}>Choose the client, service, and report scope.</p></div>
            <button type="button" className={styles.secondary} disabled={locked} onClick={onClose} aria-label="Close new report">×</button></header>
        {children}
    </dialog>, document.body);
};

export default NewConsultantReportModal;
